/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Finding { 
    severity?: Finding.SeverityEnum;
    code?: string;
    message?: string;
    ref?: string;
}
export namespace Finding {
    export type SeverityEnum = 'BLOCKER' | 'WARNING';
    export const SeverityEnum = {
        BLOCKER: 'BLOCKER' as SeverityEnum,
        WARNING: 'WARNING' as SeverityEnum
    };
}